import { CountryList, ISalesRep } from '@ml/common';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { environment } from '../../../environments/environment';
import { HomeBuyerVM } from '../models/home-buyer';

export class MattamyHomeBuyer {
  FirstName: string;
  LastName: string;
  Email: string;
  Phone?: string;
  PhoneCountryCode?: string;
  PhoneAreaCode?: string;
  Type: string;
  EmailConsent: string;
  RegistrationDate: string;
  RegistrationType: string;
  MPC: string;
  Source?: string;
  WorkingWithRealtor: string;
  FavFloorplans?: string;
  FavHomesites?: string;
  CreationMethod: string;
  RealtorName?: string;
  SEmail?: string;
  Zip?: string;
  State?: string;
  Country?: string;
  SMSConsent?: string;
  AdditionalCommunity?: string;

  constructor(
    homeBuyer: HomeBuyerVM,
    mpc: string,
    initialRegistration: boolean,
    salesRep?: ISalesRep
  ) {
    this.FirstName = homeBuyer.FirstName;
    this.LastName = homeBuyer.LastName;
    this.Email = homeBuyer.Email;
    this.Type = homeBuyer.CustomData.Type === 'No' ? 'Buyer' : 'Real Estate Agent';
    this.WorkingWithRealtor = homeBuyer.CustomData.WorkingWithRealtor === 'No' ? 'N' : 'Y';
    this.RegistrationDate = new Date(homeBuyer.CreatedOn).toISOString().split('T')[0];
    this.CreationMethod = 'Walk in-mySCP';
    this.MPC = mpc;

    this.RegistrationType = initialRegistration ? 'Initial' : 'Secondary';

    if (salesRep) this.SEmail = salesRep.Email;

    if (homeBuyer.CustomData.DisclaimerConsent) this.EmailConsent = 'Expressed';
    else this.EmailConsent = 'Implied';

    if (homeBuyer.CustomData.SMSConsent) this.SMSConsent = 'True';
    else this.SMSConsent = 'False';

    if (homeBuyer.CustomData.Zip) this.Zip = homeBuyer.CustomData.Zip;
    if (homeBuyer.CustomData.State) this.State = homeBuyer.CustomData.State;
    if (homeBuyer.CustomData.Country) {
      this.Country =
        CountryList.find(c => c.FullName === homeBuyer.CustomData.Country)?.Abreviation || '';

      // Fallback, some are saved as USA instead of full name
      if (!this.Country && homeBuyer.CustomData.Country === 'USA') this.Country = 'US';
    }
    if (homeBuyer.CustomData.Source) this.Source = homeBuyer.CustomData.Source;
    if (homeBuyer.CustomData.RealtorName) this.RealtorName = homeBuyer.CustomData.RealtorName;

    if (!environment.production && homeBuyer.CustomData.NeighborhoodsSelect?.length)
      this.AdditionalCommunity = homeBuyer.CustomData.NeighborhoodsSelect.join(',');

    if (homeBuyer.PhoneNumber) {
      this.getOptionalPhoneInformation(homeBuyer.PhoneNumber, this.Country);
    }
  }

  // Split phone number into area code and country code
  private getOptionalPhoneInformation(phoneNumber: string, countryCode: string = 'US') {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();

      const parsedNumber = phoneUtil.parse(phoneNumber, countryCode);
      const countryPhoneCode = parsedNumber.getCountryCode();
      const nationalNumber = parsedNumber.getNationalNumber();

      const nationalNumberString = nationalNumber.toString();
      if (countryCode === 'US' || countryCode === 'CA') {
        this.PhoneAreaCode = nationalNumberString.slice(0, 3);
        this.Phone = nationalNumberString.slice(3);
      } else {
        this.PhoneAreaCode = '';
        this.Phone = nationalNumberString;
      }
      this.PhoneCountryCode = countryPhoneCode.toString();
    } catch (error) {
      console.error('Error parsing phone number:', error);
    }
  }
}
